// React
import React from 'react';

// Proptype
import PropTypes from 'prop-types';

// Material UI
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { isEmpty } from 'lodash';

import { withStyles } from '@material-ui/core/styles';

// utils
import { formatCurrencyWithoutCurrency, keyEmptyCheck } from 'aurora-utils/utils';

import ADGMPanel from '../ADGMPanel';
import styles from './styles';

const ADGMFees = ({ classes, title, FEES }) => {
  if (isEmpty(FEES)) return null;
  const dariFess = {
    amount: FEES?.amount || FEES?.dariAmount || FEES?.dariServiceAmount || FEES?.dariRegAmount,
    vatCharges: FEES?.vatCharges || FEES?.vatOnRegistration || FEES?.totalVatToBePaid,
    totalAmount: FEES?.totalADGMAmount || FEES?.totalADGMServiceAmount || FEES?.totalAmount,
  };
  return (
    <ADGMPanel title={keyEmptyCheck(title || 'other_fees')}>
      <Box className={classes.feesContainer}>
        <Box component={Grid} container mb={1.7} className={classes.fees}>
          <Grid item xs={8}>
            <Typography className={classes.textBold}>
              {keyEmptyCheck('electronic_administrative_services_allowance')}
            </Typography>
          </Grid>
          <Box component={Grid} item xs={4} display='flex' justifyContent='flex-end'>
            <Typography className={classes.textBold}>
              {keyEmptyCheck('AED_amount', { num: formatCurrencyWithoutCurrency(dariFess?.amount) })}
            </Typography>
          </Box>
        </Box>
        <Box component={Grid} container className={classes.fees}>
          <Grid item xs={8}>
            <Typography className={classes.textBold}>{keyEmptyCheck('vat')}</Typography>
          </Grid>
          <Box component={Grid} item xs={4} display='flex' justifyContent='flex-end'>
            <Typography className={classes.textBold}>
              {keyEmptyCheck('AED_amount', { num: formatCurrencyWithoutCurrency(dariFess?.vatCharges) })}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box display='flex' alignItems='center' justifyContent='space-between' className={classes.totalContainer}>
        <span>{keyEmptyCheck('total_to_be_paid')}</span>
        <span>{keyEmptyCheck('AED_amount', { num: formatCurrencyWithoutCurrency(dariFess?.totalAmount) })}</span>
      </Box>
    </ADGMPanel>
  );
};

ADGMFees.propTypes = {
  classes: PropTypes.object.isRequired,
  FEES: PropTypes.object.isRequired,
  title: PropTypes.string,
};

ADGMFees.defaultProps = {
  title: '',
};
export default withStyles(styles)(ADGMFees);
